<template>
	<MainContainer
		header-selected="home"
		:hide-header="$config.public.selfHost"
		:hide-footer="$config.public.selfHost"
		:loading="status == 'pending' || state.loading"
		:fetched="status == 'success'"
		:error="error"
		fixed
		no-company-branding
		@try-again="refresh"
	>
		<template v-if="!$config.public.selfHost">
			<MainTopSection />
			<MainServicesSection />
			<MainWhatMakeUsBetterSection class="mb-[30px] mt-[50px] lg:mb-[100px] lg:mt-[70px]" />
			<MainBlogSection :articles="data?.latest_articles" class="mb-[80px]" />
		</template>
		<SelfHostLandingPage v-else :companies="data?.companies || []" />
	</MainContainer>
</template>

<script setup lang="ts">
import MainServicesSection from "~/components/main/MainServicesSection.vue"
import MainTopSection from "~/components/main/MainTopSection.vue"

const generalStore = useGeneralStore()
const route = useRoute()

definePageMeta({
	middleware: ["payroll-module-domain-lock", "career-module-domain-lock"]
})

const state = reactive({
	loading: false
})

const { data, status, error, refresh } = useLazyAsyncData(String(route.path), () => generalStore.homepage())
</script>
